(function () {
  function init() {
    var lazyVideos = document.querySelectorAll('video[data-lazy]');
    if (!lazyVideos.length) return;

    function loadVideo(video) {
      if (video.dataset.loaded) return;
      if (video.dataset.src) video.src = video.dataset.src;
      var sources = video.querySelectorAll('source[data-src]');
      for (var i = 0; i < sources.length; i++) {
        sources[i].src = sources[i].dataset.src;
      }
      video.load();
      video.dataset.loaded = 'true';
      var playPromise = video.play();
      if (playPromise !== undefined) playPromise.catch(function () {});
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            loadVideo(entry.target);
            observer.unobserve(entry.target);
          }
        });
      }, { rootMargin: '200px 0px' });
      lazyVideos.forEach(function (v) { observer.observe(v); });
    } else {
      lazyVideos.forEach(loadVideo);
    }
  }

  if (document.readyState === 'complete') {
    init();
  } else {
    window.addEventListener('load', init);
  }
})();